import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { downloadCsv, formatApiErrorDetail } from "@/lib/api";

export function ExportButton({ resource, params, label = "Export CSV" }) {
  const [loading, setLoading] = useState(false);

  const onClick = async () => {
    setLoading(true);
    try {
      const stamp = new Date().toISOString().slice(0, 10);
      await downloadCsv(resource, params, `packbrothers_${resource}_${stamp}.csv`);
      toast.success("Export downloaded");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || "Export failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Button
      variant="outline"
      data-testid={`export-${resource}-button`}
      onClick={onClick}
      disabled={loading}
      className="h-9 gap-2 rounded-full border-[var(--pb-border)] bg-white text-sm font-medium text-[#18344A] hover:bg-[rgba(24,52,74,0.04)]"
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <Download className="h-4 w-4 text-[#526E7E]" />}
      {label}
    </Button>
  );
}
